// file for handling the top filters.
//Import Libraries
import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { config } from "../../../config/config";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import InputLabel from "@mui/material/InputLabel";
import "./localreporting.scss";
import Loader from "../../../components/Loader/Loader";
import FileUpload from "../../../components/FileUpload/FileUpload";
import GlobalDropZone from "../../../components/FileUpload/GlobalDropZone";
import { useUserAuthentication } from "../../../utils/utils";
import Popover from "@mui/material/Popover";
import { useHistory } from "react-router-dom";

let api = config.api.api_url;

function MetaSearchFilter(props) {
  let {
    user,
    source_data,
    updateSourceInputs,
    isFileUploading,
    loading,
    setMappedData,
    updateAlert,
    setMappedDataCreateNew,
    isPlaceholderFetching,
  } = props;
  const [expand, setExpand] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isSffLoading, setIsSffLoading] = useState(false);
  const [isTemplateSffLoading, setIsTemplateSffLoading] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();

  const open = Boolean(anchorEl);
  const { login } = useUserAuthentication();

  const isCreateNewVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Create new" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_source == "" ||
      isFilterLoading == true ||
      isButtonLoading == true
    );
  }, [
    source_data,
    source_data.current_filter_value,
    isFilterLoading,
    isButtonLoading,
  ]);

  const isExistingVisible = useMemo(() => {
    if (
      source_data.current_filter_value === "Existing" &&
      source_data.current_filter_value !== ""
    ) {
      return false;
    }
    return (
      source_data.current_source == "" ||
      isFilterLoading == true ||
      isButtonLoading == true
    );
  }, [
    source_data,
    source_data.current_filter_value,
    isFilterLoading,
    isButtonLoading,
  ]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  // FETCH META DATA FOR SELECTED DATASET
  const handleSourceChange = async (e, selectedOption) => {
    updateSourceInputs("current_source", selectedOption.value);
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_ssfFileId", "");
  };

  // FETCH COUNTRIES FOR CHOSEN FILTER TYPE
  const handleRadioChange = async (e) => {
    setIsFilterLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_filter_value", e.target.value);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);

    // API call to get Updated SFF_File_Id based on Filter
    const params = new URLSearchParams({
      usecase_name: Use_Case_Name || "",
      source: source_data?.current_source || "",
      filtertype: e.target.value === "Existing" ? "existing" : "create",
    });

    try {
      const response = await fetch(
        api + `/local_reporting/market_mapping/getcountries?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const COUNTRIES = data.data || [];

      const FINAL_COUNTRIES =
        COUNTRIES?.filter(
          (country) =>
            country !== null && country !== undefined && country !== ""
        )?.map((item) => {
          return { label: item, value: item };
        }) ?? [];

      updateSourceInputs("current_mapped_country", FINAL_COUNTRIES);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsFilterLoading(false);
  };

  // FETCH SFF_FILE_ID'S FOR SELECTED COUNTRY
  const handleCountryChange = async (e, selectedOption) => {
    setIsSffLoading(true);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("current_country", selectedOption.label);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);

    // API call to get Updated SFF_File_Id based on Filter
    const params = new URLSearchParams({
      country_code: selectedOption?.value || "",
      source: source_data?.current_source || [],
      usecase_name: Use_Case_Name || "",
      filtertype:
        source_data?.current_filter_value === "Existing"
          ? "existing"
          : "create" || "",
    });
    try {
      const response = await fetch(
        api + `/local_reporting/market_mapping/getfileid?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const NEW_SFF_FILE_IDS = data?.data || [];

      const UPDATED_NEW_SFF_FILE_IDS =
        NEW_SFF_FILE_IDS?.filter(
          (fileid) => fileid !== null && fileid !== undefined && fileid !== ""
        )?.map((item) => {
          return { label: item, value: item };
        }) ?? [];

      updateSourceInputs("current_ssf_file_id", UPDATED_NEW_SFF_FILE_IDS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    updateSourceInputs("current_country_code", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    setIsSffLoading(false);
  };

  // FETCH TABLE DATA FOR SELECTED SFF_FILE_ID
  const handleSSFFileChange = async (e, selectedOption) => {
    setIsButtonLoading(false);
    updateSourceInputs("current_ssfFileId", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("is_file_uploaded", false);
    updateSourceInputs("isAnyRecordDeleted", false);

    // fetch PLACEHOLDER_DATA if "Create new" is selected
    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code
    );

    if (true) {
      setMappedData(
        selectedOption.value || "",
        Use_Case_Name || "",
        source_data?.current_source || "",
        source_data?.current_country || ""
      );
    } else {
      setMappedDataCreateNew(
        source_data?.current_target_gold_layer?.value || "",
        source_data?.current_country || "",
        Country_Code
          ? Country_Code?.value || ""
          : source_data?.current_country || "",
        source_data?.current_ssfFileId || "",
        "default",
        source_data?.current_target_gold_layer?.label || ""
      );
    }
  };

  // GET PLACEHOLDER DATA FOR SELECTED SFF_FILE_ID - ONLY FOR CREATE NEW FILTER
  const handlePlaceholderFile = async () => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  const handleExistingTemplate = async (event) => {
    let originalArray = source_data.current_ssf_file_id;
    const filteredSffFileId = originalArray.filter(
      (item) => item.value !== source_data.current_ssfFileId
    );
    updateSourceInputs("current_template_ssf_file_id", filteredSffFileId);
    setAnchorEl(event.currentTarget);
  };

  // FETCH TABLE DATA FOR SELECTED SFF_FILE_ID
  const handleSSFFileChangeAfterTemplate = async (e, selectedOption) => {
    setAnchorEl(null);
    setIsButtonLoading(false);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("current_template_ssfFileId", selectedOption.value);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("appliedFilters", []);

    // fetch PLACEHOLDER_DATA if "Create new" is selected
    const Country_Code = source_data.master_table_countries.find(
      (item) =>
        item.label.toUpperCase() === source_data.current_country ||
        item.value.toUpperCase() === source_data.current_country_code
    );

    await setMappedDataCreateNew(
      source_data.current_target_gold_layer.value,
      source_data.current_country,
      Country_Code ? Country_Code.value : source_data.current_country,
      selectedOption.value,
      "default",
      source_data.current_target_gold_layer.label
    );
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {!is_Approver && (
        <div className="cnc-toggle-icon">
          <label
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "Collapse" : "Expand"}
          </label>
          <i
            className="material-icons"
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {!expand ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </i>
        </div>
      )}

      {!expand && (
        <div className="cnc-model-header-mapping">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)", // 5 equal-width columns
              gridTemplateRows: "1fr", // 1 row
              gap: "12px", // gap between columns (and rows if any)
              padding: "2px 15px 0px 15px",
              width: "100%",
            }}
          >
            <>
              {/* DATASETS */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Source:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data.current_mapped_source}
                    loading={
                      loading &&
                      (source_data.current_mapped_source ||
                        source_data.current_mapped_source.length === 0)
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSourceChange}
                    value={
                      source_data.current_source &&
                      source_data.current_source.length > 0
                        ? {
                            label: source_data.current_source,
                            value: source_data.current_source,
                          }
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_source === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        height: "36px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* FILTERS - CREATE NEW OR EXISTING */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Choose Filter:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div
                  className="radio-input-container"
                  style={{ marginBottom: "15px" }}
                >
                  {/* Insert New */}
                  <div className="radio-input-div">
                    <input
                      id="all-checkbox"
                      type="radio"
                      value="Create new"
                      disabled={isCreateNewVisible ? true : false}
                      name="filter"
                      checked={
                        source_data.current_filter_value === "Create new"
                      }
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"all-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Create new
                    </InputLabel>
                  </div>

                  {/* Existing */}
                  <div className="radio-input-div">
                    <input
                      id="Unmapped-checkbox"
                      type="radio"
                      value="Existing"
                      disabled={isExistingVisible ? true : false}
                      name="filter"
                      checked={source_data.current_filter_value === "Existing"}
                      onChange={handleRadioChange}
                      className="radio-checkbox-label"
                    />
                    <InputLabel
                      htmlFor={"Unmapped-checkbox"}
                      className="radio-checkbox-label"
                    >
                      Existing
                    </InputLabel>
                  </div>
                </div>
              </div>

              {/* COUNTRY */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select Country Code:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    disabled={
                      !source_data.current_filter_value ||
                      source_data.current_filter_value.length === 0
                    }
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data?.current_mapped_country || []}
                    loading={isFilterLoading}
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleCountryChange}
                    value={
                      {
                        label: source_data.current_country,
                        value: source_data.current_country_code,
                      } || null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_filter_value === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_filter_value === ""
                            ? "#d6d6d6"
                            : "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        height: "36px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                    }}
                    // sx={{
                    //   width: "100%",
                    //   "& .MuiOutlinedInput-root": {
                    //     backgroundColor:
                    //       source_data.current_filter_value === ""
                    //         ? "#d6d6d6"
                    //         : "#fff",
                    //     fontFamily: "Hind Siliguri",
                    //     borderRadius: "6px",
                    //     fontSize: "13px",
                    //     fontWeight: "400",
                    //     color: "#333",
                    //     height: "36px",
                    //     paddingRight: "36px", // space for dropdown icon
                    //   },
                    //   "& .MuiOutlinedInput-input": {
                    //     padding: "8px 12px",
                    //   },
                    //   "& .MuiAutocomplete-endAdornment": {
                    //     right: "12px",
                    //     top: "50%",
                    //     transform: "translateY(-50%)", // vertical center alignment
                    //   },
                    //   "& .MuiSvgIcon-root": {
                    //     color: "#999",
                    //   },
                    // }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>

              {/* SFF FILE ID  */}
              <div>
                <div
                  className="mg-model-header-item"
                  style={{ height: "25px" }}
                >
                  Select SFF File ID:{" "}
                  <p
                    style={{
                      display: "inline",
                      color: "red",
                      fontSize: 16,
                    }}
                  >
                    *
                  </p>
                </div>
                <div className="" style={{ marginBottom: "15px" }}>
                  <Autocomplete
                    id="country-select"
                    disableClearable
                    size="small"
                    options={source_data?.current_ssf_file_id || []}
                    loading={isSffLoading}
                    disabled={
                      !source_data.current_country ||
                      source_data.current_country.length === 0
                    }
                    loadingText={<Loader />}
                    getOptionLabel={(option) => option.label}
                    onChange={handleSSFFileChange}
                    value={
                      source_data.current_ssfFileId &&
                      source_data.current_ssfFileId.length > 0
                        ? {
                            label: source_data.current_ssfFileId,
                            value: source_data.current_ssfFileId,
                          }
                        : null
                    }
                    popupIcon={
                      <span
                        className="material-icons"
                        style={{
                          fontSize: "20px",
                          color:
                            source_data.current_country === ""
                              ? "f7f7f7"
                              : "#555",
                        }}
                      >
                        arrow_drop_down
                      </span>
                    }
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          source_data.current_country === ""
                            ? "#d6d6d6"
                            : "#fff",
                        borderRadius: "6px",
                        fontSize: "13px",
                        height: "36px",
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "8px 12px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "1px",
                      },
                    }}
                    // sx={{
                    //   width: "100%",
                    //   "& .MuiOutlinedInput-root": {
                    //     backgroundColor:
                    //       source_data.current_country === ""
                    //         ? "#d6d6d6"
                    //         : "#fff",
                    //     fontFamily: "Hind Siliguri",
                    //     borderRadius: "6px",
                    //     fontSize: "13px",
                    //     fontWeight: "400",
                    //     color: "#333",
                    //     height: "36px",
                    //     paddingRight: "36px", // space for dropdown icon
                    //   },
                    //   "& .MuiOutlinedInput-input": {
                    //     padding: "8px 12px",
                    //   },
                    //   "& .MuiAutocomplete-endAdornment": {
                    //     right: "12px",
                    //     top: "50%",
                    //     transform: "translateY(-50%)", // vertical center alignment
                    //   },
                    //   "& .MuiSvgIcon-root": {
                    //     color: "#999",
                    //   },
                    // }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        // label="Select Country"
                        InputLabelProps={{
                          style: {
                            fontSize: "13px",
                          },
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{
                          fontSize: "12px",
                          fontWeight: "normal",
                          color: "#212529",
                        }}
                      >
                        {option.label}
                      </li>
                    )}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      )}
    </>
  );
}

MetaSearchFilter.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  cncData: PropTypes.object,
  brand_data: PropTypes.object,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateSourceInputs,
  updateAlert,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetaSearchFilter)
);
